module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  

var inputPurpose = ["on",'off','name',"honorific-prefix","given-name","additional-name","family-name","honorific-suffix",
"nickname","organization-title","username","new-password","current-password","one-time-code","organization", "street-address",
"address-line1", "address-line2", "address-line3", "address-level4","address-level3","address-level2","address-level1","country",
"country-name","postal-code","cc-name","cc-given-name","cc-additional-name","cc-family-name","cc-number","cc-exp","cc-exp-month",
"cc-exp-year","cc-csc","cc-type","transaction-currency","transaction-amount","language","bday", "bday-day","bday-month","bday-year",
"sex","url","photo","tel","tel-country-code","tel-national","tel-area-code","tel-local","tel-local-prefix","tel-local-suffix","tel-extension",
"email","impp"];

    ; __append("\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 subsection nopadding-r\">\r\n        <label class=\"prop-sublabel label-60\">Autofill</label>\r\n        <div>\r\n            <div id=\"main_text_format\">\r\n                <select name=\"autocomplete\" id=\"autocomplete\">\r\n                    ")
    ;  for (var i = 0; i < inputPurpose.length; i++) { 
    ; __append("\r\n                        <option value=\"")
    ; __append(escapeFn(inputPurpose[i]))
    ; __append("\">")
    ; __append(escapeFn(_.startCase(inputPurpose[i])))
    ; __append("</option>\r\n                        ")
    ;  }; 
    ; __append("\r\n                </select>\r\n            </div>\r\n        </div>\r\n    </div>\r\n    \r\n</div>")
  }
  return __output;

}